import Vue from "vue"
import Vapi from "vuex-rest-api"

const places = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    place: null,
    places: [],
    allPlaces: [],
  },
})

  // places
  .get({
    action: "retrievePlace",
    property: "place",
    path: ({ id }) => `/places/${id}/`,
  })
  .get({
    action: "listPlaces",
    property: "places",
    path: "/places/",
  })
  .get({
    action: "listAllPlaces",
    property: "allPlaces",
    path: "/places/?no_page=1",
  })
  .post({
    action: "createPlace",
    property: "place",
    path: "/places/",
  })
  .patch({
    action: "updatePlace",
    property: "place",
    path: ({ id }) => `/places/${id}/`,
  })
  .delete({
    action: "destroyPlace",
    path: ({ id }) => `/places/${id}/`,
  })

  // finalize
  .getStore()

export default places
